import ChatIcon from '@mui/icons-material/Chat';
import KeyboardVoiceIcon from '@mui/icons-material/KeyboardVoice';
import LocalPostOfficeIcon from '@mui/icons-material/LocalPostOffice';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { Communication } from '../../../../../../../services/api-client/contact-api';
import { TemplateTransportType } from '../../../../../../../types/communication/transport-type';

export const getCommIcon = (comm: Communication) => {
  switch (comm.type) {
    case TemplateTransportType.Email:
      return <MailOutlineIcon />;
    case TemplateTransportType.Postcard:
    case TemplateTransportType.Letter:
      return <LocalPostOfficeIcon />;
    case TemplateTransportType.Sms:
    case TemplateTransportType.IncomingSms:
      return <ChatIcon />;
    case TemplateTransportType.Voice:
      return <KeyboardVoiceIcon />;
    default:
      return null;
  }
};
